export default __webpack_public_path__ + "e-commerce4cea77.jpg";